import { FileText } from "lucide-react";
import type { Card, CardAction } from "../../types/chat";

interface Props {
  card: Card;
  onAction: (action: CardAction) => void;
}

export function FileCard({ card, onAction }: Props) {
  const files = (card.data.files as Array<Record<string, unknown>>) ?? [];

  return (
    <div className="rounded-lg border bg-card p-3" role="region" aria-label="Files">
      <div className="flex flex-col gap-1.5">
        {files.slice(0, 5).map((file, i) => (
          <div key={i} className="flex items-center gap-2 text-sm">
            <FileText className="size-4 text-muted-foreground shrink-0" />
            <span className="font-medium truncate">{String(file.name ?? "Untitled")}</span>
            {file.size != null && <span className="text-xs text-muted-foreground shrink-0">{formatSize(Number(file.size))}</span>}
          </div>
        ))}
      </div>
      {card.actions?.map((action) => (
        <button key={action.id} onClick={() => onAction(action)} className="mt-2 text-xs text-primary hover:underline">
          {action.label}
        </button>
      ))}
    </div>
  );
}

function formatSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
